import convertOrderLineToGoogleTagManagerItem from "./convertOrderLineToGoogleTagManagerItem";
import { ORDER_LINE_TYPE, } from "../../../../assets/react/Webshop/types/ShoppingCart";
export class GoogleTagManagerProvider {
    constructor() {
        this.currency = "NOK";
    }
    // This is used when one operation can both add and remove items
    // from the cart. The only example I can think of is the
    // desktop "digital mini cart"-ordering
    onCartChange(cartUpdate) {
        this.clearDatalayerEcommerce();
        console.log("Cart update!", cartUpdate);
        if (cartUpdate.newOrderLines && cartUpdate.newOrderLines.length > 0) {
            this.trackItemsEvent("add_to_cart", cartUpdate.newOrderLines);
        }
        if (cartUpdate.removedOrderLines &&
            cartUpdate.removedOrderLines.length > 0) {
            this.trackItemsEvent("remove_from_cart", cartUpdate.removedOrderLines);
        }
    }
    onLogin(user) {
        const encoder = new TextEncoder();
        const data = encoder.encode(user.emailAddress);
        // Create a sha-256-hash
        crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
            // Convert the ArrayBuffer to hex string
            const emailHashArray = Array.from(new Uint8Array(hashBuffer));
            const emailHex = emailHashArray
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
            const event = {
                event: "login",
                login_status: "logged in",
                email: emailHex,
                user_id: user.uuid,
            };
            window.dataLayer.push(event);
        });
    }
    onRegisterUser(user) {
        this.onLogin(user);
    }
    onPageUser(user) {
        const encoder = new TextEncoder();
        const data = encoder.encode(user.emailAddress);
        // Create a sha-256-hash
        crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
            // Convert the ArrayBuffer to hex string
            const emailHashArray = Array.from(new Uint8Array(hashBuffer));
            const emailHex = emailHashArray
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
            const event = {
                event: "login",
                login_status: user.isAnonymousUser ? "logged out" : "logged in",
            };
            if (!user.isAnonymousUser) {
                event.email = emailHex;
                event.user_id = user.uuid;
            }
            window.dataLayer.push(event);
        });
    }
    onAddToCart(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("add_to_cart", items);
    }
    onRemoveFromCart(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("remove_from_cart", items);
    }
    onViewCart(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("view_cart", items);
    }
    onBeginCheckout(items) {
        this.clearDatalayerEcommerce();
        this.trackItemsEvent("begin_checkout", items);
    }
    onPurchaseSuccessful(order) {
        const totalSum = order.summary.totalPrice;
        // Type 4 is TOTAL, not tax - reading tax off it reported the whole order
        // total as tax. VAT is type 5, and there is one line per distinct rate, so
        // it has to be summed rather than first-matched.
        const tax = this.lineTotal(order, ORDER_LINE_TYPE.VAT);
        const shippingFee = this.lineTotal(order, ORDER_LINE_TYPE.DELIVERY);
        const items = order.orderLines.filter((item) => {
            return item.type === ORDER_LINE_TYPE.PRODUCT && "uuid" in item;
        });
        const eventData = {
            currency: this.currency,
            transaction_id: order.uuid,
            value: totalSum.toFixed(2),
            tax: tax.toFixed(2),
            shipping: shippingFee.toFixed(2),
            coupon: order.rebateCode,
            items: items
                .map((item) => {
                return convertOrderLineToGoogleTagManagerItem(item);
            })
                .filter((item) => item !== null),
        };
        window.gtag("event", "purchase", eventData);
    }
    trackItemsEvent(eventName, items) {
        const eventData = {
            currency: this.currency,
            value: this.calculateTotalValue(items).toFixed(2),
            items: items
                .map((item) => {
                return convertOrderLineToGoogleTagManagerItem(item);
            })
                .filter((item) => item !== null),
        };
        console.log(`[GTM-event] ${eventName}`, items, eventData);
        window.gtag("event", eventName, eventData);
    }
    setAllowTracking(value) {
        window.gtag("consent", "update", {
            analytics_storage: value ? "granted" : "denied",
        });
    }
    setCurrency(code) {
        this.currency = code;
    }
    lineTotal(order, type) {
        return order.orderLines
            .filter((line) => line.type === type)
            .reduce((sum, line) => sum + line.linePrice, 0);
    }
    calculateTotalValue(items) {
        return items.reduce((totalSum, orderLine) => {
            totalSum += orderLine.actualLinePrice;
            return totalSum;
        }, 0);
    }
    clearDatalayerEcommerce() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ecommerce: null,
        });
        console.log("[gtag] Clear dataLayer");
    }
}
